// chillandout cart bridge — Horizon ↔ chill-cart-drawer interop.
//
// Two responsibilities:
// 1. Intercept clicks on Horizon's <cart-icon> (and any /cart link) and
//    dispatch the `cart:open` event our chill drawer listens for.
// 2. Keep Horizon's <cart-bubble> count in sync with our drawer's AJAX ops.
//
// Loaded site-wide via snippets/scripts.liquid. Defer-loaded (not module).
// Budget: ~1.5 KB gzip. No deps.
//
// Spec: docs/MASTER-BRIEF.md §10.5 (cart drawer integration)

(function () {
  'use strict';

  const TRIGGER_SELECTOR = 'cart-icon, [data-cart-trigger], a[href$="/cart"], a[href*="/cart?"]';
  const BUBBLE_SELECTOR = '.cart-bubble';
  const BUBBLE_COUNT_SELECTOR = '[ref="cartBubbleCount"], .cart-bubble__text-count';

  // ---------- Click intercept ----------

  document.addEventListener('click', function (e) {
    // Preserve "open in new tab" intent — Maya cmd-clicks.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (e.defaultPrevented) return;

    const trigger = e.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    // Don't hijack the bubble that lives inside the cart drawer itself.
    if (trigger.closest('cart-drawer')) return;

    e.preventDefault();
    document.dispatchEvent(new CustomEvent('cart:open'));
  });

  // ---------- Bubble live update ----------

  function updateBubble(cart) {
    if (!cart) return;
    const count = cart.item_count || 0;

    document.querySelectorAll(BUBBLE_SELECTOR).forEach(function (bubble) {
      // Don't touch the drawer's own bubble (it re-renders via Section Rendering API).
      if (bubble.closest('cart-drawer')) return;

      if (count <= 0) {
        bubble.classList.add('visually-hidden');
      } else {
        bubble.classList.remove('visually-hidden');
      }
    });

    document.querySelectorAll(BUBBLE_COUNT_SELECTOR).forEach(function (countEl) {
      if (countEl.closest('cart-drawer')) return;

      // Horizon hides the count past 99 with the "99+" rule via data-maintain-ratio
      // sibling logic, but the text itself just shows the number. We mirror that.
      const display = count > 99 ? '99+' : String(count);
      countEl.textContent = display;
      if (count > 0) {
        countEl.classList.remove('hidden');
      } else {
        countEl.classList.add('hidden');
      }
    });
  }

  function refreshFromServer() {
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateBubble(cart); })
      .catch(function () { /* network blip — leave the bubble as-is */ });
  }

  document.addEventListener('cart:updated', function (e) {
    // chill-cart-drawer dispatches with detail.cart sometimes; fall back to /cart.js.
    if (e && e.detail && e.detail.cart) {
      updateBubble(e.detail.cart);
    } else {
      refreshFromServer();
    }
  });
})();
